import React from 'react';

function Footer () {
    return (
            <section class="card bg-secondary border-top">
                <div class="card-body text-center blanco">             
                    <h5>Aviso de privacidad</h5>
                </div>
            </section>
    )
}

export default Footer